/**
 * KAN-964: строка-ссылка на главной /m: "Встречи и звонки на сегодня: N" (и просроченные)
 * ведёт во вкладку "Встречи". Пока данных нет или на сегодня ничего, строки нет.
 */
import { CalendarClock, ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useTodaySteps } from '@/hooks/useTodaySteps'
import { MOBILE_MEETINGS_PATH } from '@/lib/mobileApp'

export function TodayStepsLink({ className = '' }: { className?: string }) {
  const { data } = useTodaySteps()
  const total = data?.total ?? 0
  const overdue = data?.overdue_count ?? 0
  if (total === 0 && overdue === 0) return null

  return (
    <Link
      to={MOBILE_MEETINGS_PATH}
      data-testid="today-steps-link"
      className={`flex min-h-[48px] items-center gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3 shadow-sm active:bg-gray-100 ${className}`}
    >
      <CalendarClock className="h-5 w-5 shrink-0 text-blue-600" aria-hidden="true" />
      <span className="min-w-0 flex-1 text-sm font-medium text-gray-900">
        Встречи и звонки на сегодня: {total}
        {overdue > 0 && <span className="text-red-600">, просрочено: {overdue}</span>}
      </span>
      <ChevronRight className="h-5 w-5 shrink-0 text-gray-400" aria-hidden="true" />
    </Link>
  )
}
